import {getStyleForUserReviewTag, UserReviewTags} from "enums";
import React, {FC} from "react";
import {ModerationUserTag} from "interfaces";

export interface Tag {
    tag: UserReviewTags,
    info: string
}

export interface TagProps {
    tag: ModerationUserTag
}

const renderPhotoInfo = (tag: UserReviewTags, info?: string) => {
    const shouldDisplayInfo = ![
        UserReviewTags.UpdatedPhotos,
        UserReviewTags.DuplicateHashPhoto,
        UserReviewTags.ManualSensitivePhoto,
        UserReviewTags.SensitivePhoto,
        UserReviewTags.ExplicitSensitivePhoto,
        UserReviewTags.SafeSensitivePhoto,
    ].includes(tag)

    if (!shouldDisplayInfo || !info) {
        return null;
    }
    
    if (tag === UserReviewTags.CelebrityPhoto) {
        if (!info) {
            return null
        }

        try {
            const infoObj = JSON.parse(info) as Array<{
                Name: string,
                Urls: string[],
                MatchConfidence: number
            }>;
            const names = infoObj.map(o => o.Name).join(', ')
            return <span key={tag}
                         title={info}
                         className={`badge text-wrap text-start text-black`}
                         style={{fontWeight: 400}}>{names}</span>
        } catch (err) {
            return null
        }
    } else {
        const infos = info?.split(/\n(?:Abuse reason|Labels|Age ranges|QR text):/);
        const infoString = infos ? infos.length > 1 ? infos[1] : infos[0] : undefined
        return <span key={tag}
                     title={info}
                     className={`badge text-wrap text-start text-black`}
                     style={{fontWeight: 400}}>{infoString}</span>
    }

}

export const ModerationPhotoTag: FC<TagProps> = ({tag}) => {
    const style = getStyleForUserReviewTag(tag.tag);

    return <div className="d-flex align-items-start w-100 flex-wrap">
        <span className={`badge ${style.bg} ${style.text}`} style={style.style}>#{tag.tag}</span>
        {renderPhotoInfo(tag.tag, tag.info)}
    </div>
}